module.exports = __webpack_public_path__ + "static/media/tool_cisco_cybervision.dd65c743.png";